module.exports = __webpack_public_path__ + "img/cover-slot-bg.58fe97b3.jpg";